
import TableList from "@components/templates/tablelist";
import { HttpLogisticsList, HttpCancelLogisticsOne, HttpSubmitLogisticsOne, HttpAddressList, HttpUpdateLogistics } from "@/service/headlogistics";
import { mapState, mapGetters } from "vuex";
import comIndex from './update/index'
import comPlan from './../inbound/billclient/update'
import compSeelogistics from './newSeelogistics'
import comIncharge from './setInCharge'
import mixinlist from './mixin'
export default {
    mixins: [TableList, mixinlist],
    components: {
        comIndex,
        compSeelogistics,
        comIncharge,
        comPlan
    },
    data() {
        return {
            // totals: 0,
            isMixin: true,
            Tools: { show: true },
            Tabs: { show: true },
            formData: {
                search: {
                    'quanbu': 0,
                    // 'IN_orderStatus':null,
                }
            },
            exportdata:{},
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            datename: '',
            datetime: '',
            Plugins: { show: true },
            initData: '',
            addressCodeList: []
        };
    },
    created () {
        HttpAddressList({
            'search[EQ_warehouseType]':2,
            rows: 1000,
        }).then(res=>{
            this.addressCodeList = res.data.content.map(item => {
                return {
                    label: item.code,
                    value: item.code
                }
            })
        },err=>{
            this.$Message.error(err.message);
        })
    },
    methods: {
        ajaxRequest: HttpLogisticsList,
        handleParams (params) {
            console.log(params)
            // 全部
            params.navtabType = 0
            if (params.search.quanbu === 0) {
                params.navtabType = 0

                delete params.search.quanbu
                delete params.search.daishenhe
                delete params.search.daidingcang
                delete params.search.daifachuan
                delete params.search.daiqingguan
                delete params.search.daiyuyue
                delete params.search.daituotou
                delete params.search.daiscfp
                delete params.search.yifachuan
                delete params.search.yichang
                delete params.search.yidaituotou
                delete params.search.jianyanzhong
                // return params
            }
            // 待审核
            if (params.search.daishenhe === 0) {
                params.navtabType = 1
                // params.search.IN_orderStatus = 1
                let target = [1]
                params.search.IN_orderStatus = this.handleSearch(target, params.search.IN_orderStatus)
                // params.search.IN_logisticsStatus = 0
                if (params.search.IN_orderStatus.length === 0) {
                    params.search.IN_orderStatus =  target
                }
                delete params.search.daishenhe
                delete params.search.daidingcang
                delete params.search.daifachuan
                delete params.search.daiqingguan
                delete params.search.daiyuyue
                delete params.search.daituotou
                delete params.search.daiscfp
                delete params.search.yifachuan
                delete params.search.quanbu
                delete params.search.yichang
                delete params.search.yidaituotou
                delete params.search.jianyanzhong
                // return params
            }
            // 待订舱
            if (params.search.daidingcang === 0) {
                params.navtabType = 2
                // params.search.IN_orderStatus = [6,3]
                // params.search.IN_orderStatus = [3, 6]
                let target = [3, 6]
                params.search.IN_orderStatus = this.handleSearch(target, params.search.IN_orderStatus)
                // params.search.IN_logisticsStatus = [1,0]
                if (params.search.IN_orderStatus.length === 0) {
                    params.search.IN_orderStatus =  target
                }
                delete params.search.daidingcang
                delete params.search.daifachuan
                delete params.search.daiqingguan
                delete params.search.daiyuyue
                delete params.search.daituotou
                delete params.search.daiscfp
                delete params.search.yifachuan
                delete params.search.quanbu
                delete params.search.yichang
                delete params.search.daishenhe
                delete params.search.yidaituotou
                delete params.search.jianyanzhong
                // return params
            }
            // 待发船
            else if (params.search.daifachuan === 0) {
                params.navtabType = 3
                // params.search.IN_orderStatus = 6
                // params.search.IN_orderStatus = [14, 19]
                let target = [14, 19]
                params.search.IN_orderStatus = this.handleSearch(target, params.search.IN_orderStatus)
                // params.search.IN_logisticsStatus = [2,3]
                if (params.search.IN_orderStatus.length === 0) {
                    params.search.IN_orderStatus =  target
                }
                delete params.search.daidingcang
                delete params.search.daifachuan
                delete params.search.daiqingguan
                delete params.search.daiyuyue
                delete params.search.daituotou
                delete params.search.daiscfp
                delete params.search.yifachuan
                delete params.search.quanbu
                delete params.search.yichang
                delete params.search.daishenhe
                delete params.search.yidaituotou
                delete params.search.jianyanzhong
                // return params
            }
            // 已发船
            else if (params.search.yifachuan === 0) {
                params.navtabType = 4
                // params.search.IN_orderStatus = 7
                // params.search.IN_logisticsStatus = 4
                // params.search.IN_orderStatus = 7
                let target = [7]
                params.search.IN_orderStatus = this.handleSearch(target, params.search.IN_orderStatus)
                if (params.search.IN_orderStatus.length === 0) {
                    params.search.IN_orderStatus =  target
                }
                delete params.search.daidingcang
                delete params.search.daifachuan
                delete params.search.daiqingguan
                delete params.search.daiyuyue
                delete params.search.daituotou
                delete params.search.daiscfp
                delete params.search.yifachuan
                delete params.search.quanbu
                delete params.search.yichang
                delete params.search.daishenhe
                delete params.search.yidaituotou
                delete params.search.jianyanzhong
                // return params
            }
            // 待清关
            else if (params.search.daiqingguan === 0) {
                params.navtabType = 5
                // params.search.IN_orderStatus = 7
                let target = [7]
                params.search.IN_orderStatus = this.handleSearch(target, params.search.IN_orderStatus)
                if (params.search.IN_orderStatus.length === 0) {
                    params.search.IN_orderStatus =  target
                }
                // params.search.IN_logisticsStatus = 4

                delete params.search.daidingcang
                delete params.search.daifachuan
                delete params.search.daiqingguan
                delete params.search.daiyuyue
                delete params.search.daituotou
                delete params.search.daiscfp
                delete params.search.yifachuan
                delete params.search.quanbu
                delete params.search.yichang
                delete params.search.daishenhe
                delete params.search.yidaituotou
                delete params.search.jianyanzhong
                // return params
            }
            // 待预约
            else if (params.search.daiyuyue === 0) {
                params.navtabType = 6
                let target = [8, 15, 20]
                params.search.IN_orderStatus = this.handleSearch(target, params.search.IN_orderStatus)
                if (params.search.IN_orderStatus.length === 0) {
                    params.search.IN_orderStatus =  target
                }
                delete params.search.daidingcang
                delete params.search.daifachuan
                delete params.search.daiqingguan
                delete params.search.daiyuyue
                delete params.search.daituotou
                delete params.search.daiscfp
                delete params.search.yifachuan
                delete params.search.quanbu
                delete params.search.yichang
                delete params.search.daishenhe
                delete params.search.yidaituotou
                delete params.search.jianyanzhong
                // return params
            }
            // 待妥投
            else if (params.search.daituotou === 0) {
                params.navtabType = 7
                let target = [16, 18]
                params.search.IN_orderStatus = this.handleSearch(target, params.search.IN_orderStatus)
                if (params.search.IN_orderStatus.length === 0) {
                    params.search.IN_orderStatus =  target
                }
                delete params.search.daidingcang
                delete params.search.daifachuan
                delete params.search.daiqingguan
                delete params.search.daiyuyue
                delete params.search.daituotou
                delete params.search.daiscfp
                delete params.search.yifachuan
                delete params.search.quanbu
                delete params.search.yichang
                delete params.search.daishenhe
                delete params.search.yidaituotou
                delete params.search.jianyanzhong
                // return params
            }
            // 已妥投
            else if (params.search.yidaituotou === 0) {
                params.navtabType = 8
                let target = [17]
                params.search.IN_orderStatus = this.handleSearch(target, params.search.IN_orderStatus)
                if (params.search.IN_orderStatus.length === 0) {
                    params.search.IN_orderStatus =  target
                }
                delete params.search.daidingcang
                delete params.search.daifachuan
                delete params.search.daiqingguan
                delete params.search.daiyuyue
                delete params.search.daituotou
                delete params.search.daiscfp
                delete params.search.yifachuan
                delete params.search.quanbu
                delete params.search.yichang
                delete params.search.daishenhe
                delete params.search.yidaituotou
                delete params.search.jianyanzhong
                // return params
            }
            // 待上传发票
            else if (params.search.daiscfp === 0) {
                params.navtabType = 8
                let target = [17]
                params.search.IN_orderStatus = this.handleSearch(target, params.search.IN_orderStatus)
                if (params.search.IN_orderStatus.length === 0) {
                    params.search.IN_orderStatus =  target
                }
                params.search.EQ_invoiceStatus = 10
                params.search.EQ_carrierType = 0

                delete params.search.daidingcang
                delete params.search.daifachuan
                delete params.search.daiqingguan
                delete params.search.daiyuyue
                delete params.search.daituotou
                delete params.search.daiscfp
                delete params.search.yifachuan
                delete params.search.quanbu
                delete params.search.yichang
                delete params.search.daishenhe
                delete params.search.yidaituotou
                delete params.search.jianyanzhong
                // return params
            }
            // 异常
            else if (params.search.yichang === 0) {
                params.navtabType = 9
                params.search.IN_exceptionStatus = [3, 4, 5, 6, 7, 8]

                delete params.search.daidingcang
                delete params.search.daifachuan
                delete params.search.daiqingguan
                delete params.search.daiyuyue
                delete params.search.daituotou
                delete params.search.daiscfp
                delete params.search.yifachuan
                delete params.search.quanbu
                delete params.search.yichang
                delete params.search.daishenhe
                delete params.search.yidaituotou
                delete params.search.jianyanzhong
                // return params
            }
            
            this.exportdata = params
            return params
        },
        interceptRequest(params) {
            return this.handleParams(params)
        },
        toolsRender() {
            return <div>
                {this.getCurrentTabNote}
            </div>
        },
        handleOperates(params = "", type, batch) {
            if (batch === true) {
                params = (params || this.checkedData.join(',')) + '';
                if (!params.length) return this.$VMessage.warning(this.$t('global.common.choose_one', { defaultValue: '请选择至少一条数据' }));
            }
            switch (type) {
                case "add":
                    this.$router.push({
                        name: 'createheadlogistics',
                        params: { type: "add", jump: 'logistics' },
                        // query: { id: params },
                    });
                    break;
                case "edit":
                    this.$router.push({
                        name: 'headlogiticsUpdate',
                        params: { type: "edit" },
                        query: { id: params },
                    });
                    break;
                case "query":
                    this.operate = {
                        title: this.$t('global.common.query', { defaultValue: '查看' }),
                        show: true,
                        width: 1200,
                        component: "comIndex",
                        activeid: params,
                        querytype: 'query',
                        showFooter: false
                    }
                    break;
                case "queryBlank":
                    var url = this.$router.resolve({
                        name: "headlogiticsUpdate",
                        params: { type: "query" },
                        query: { id: params },
                    });
                    window.open(url.href, '_blank');
                    break;
                case 'queryPlan':
                    {
                        this.operate = {
                            title: this.$t('global.common.query', { defaultValue: '查看' }),
                            show:true,
                            width:1200,
                            component: "comPlan",
                            activeid:params,
                            querytype:'query',
                            showFooter:false,
                            alertbox:'alertbox'
                        }
                    }
                    break
                case 'queryPlanBlank':
                    {
                        window.open(this.$router.resolve({
                            name: "inboundBillclientDetail",
                            params: { type:'query' },
                            query: { no: params },
                        }).href, '_blank');
                    }
                    break
                case "submitbox":
                    this.operate = {
                        show: true,
                        alert: "error",
                        title: this.$t('global.common.update_submit', { defaultValue: "提交" }),
                        width: 460,
                        params: { orderId: params },
                        formdata: [
                            {
                                tag: "vTextarea",
                                key: "remark",
                                span: 24,
                                label: this.$t('global.common.notes', { defaultValue: "备注" }),
                                required: false,
                            }
                        ],
                        ajaxRequest: HttpSubmitLogisticsOne
                    };
                    break;
                case "cancel":
                    this.operate = {
                        show: true,
                        alert: "error",
                        title: this.$t('global.common.operate_cancel', { defaultValue: "取消" }),
                        width: 460,
                        params: { orderId: params },
                        formdata: [
                            {
                                tag: "vTextarea",
                                key: "reason",
                                span: 24,
                                label: this.$t('global.common.notes', { defaultValue: "备注" }),
                            }
                        ],
                        ajaxRequest: HttpUpdateLogistics,
                        interceptRequest: (reqData) => {
                            return {
                                headId: params,
                                isSub: false,
                                type: 32,
                                content: {},
                                attachments: [],
                                remark: reqData.reason
                            }
                        }
                    };
                    break;
                case "seelogistics":
                    this.operate = {
                        title: this.$t('fbb.inbound.view_logistics', { defaultValue: '查看物流' }),
                        show: true,
                        width: 1200,
                        component: "compSeelogistics",
                        orderid: params,
                        querytype: 'query',
                        boxtype: 'headlogistics',
                        showFooter: false
                    }
                    break;
                case 'inCharge':
                    this.operate = {
                        title: this.$t('fbb.headlogistics.set_incharge', { defaultValue: '指定负责人' }),
                        show: true,
                        component: "comIncharge",
                        id: params,
                        showFooter: false
                    }
                break
                case 'export':
                    this.handleWebfs(process.env.VUE_APP_APIURL_FBB + "/api/v2/LogisticsHead/export", 
                    this.exportdata
                    , {
                        executor: 'request',
                        download: true,
                    }).catch(err => {
                        this.$VMessage.error(err.message);
                    })
                    break
            }
        },
        getOperateNodeMap(row) {
            const { id, orderStatus } = row
            return [
                {
                    label: this.$t('global.common.update_submit', { defaultValue: "提交" }),
                    show: (orderStatus == 0 || orderStatus == 2) && this.handleAuth('fbb.logisticsHead.create'),
                    params: id,
                    operate: 'submitbox'
                },
                {
                    label: this.$t('global.common.query', { defaultValue: '查看' }),
                    show: true,
                    params: id,
                    operate: 'query'
                },
                {
                    label: this.$t('global.common.edit', { defaultValue: '编辑' }),
                    show: (orderStatus == 10 || orderStatus == 0 || orderStatus == 2) && this.handleAuth('fbb.logisticsHead.create'),
                    params: id,
                    operate: 'edit'
                }, {
                    label: this.$t('global.common.operate_cancel', { defaultValue: '取消' }),
                    show: (orderStatus == 10 || orderStatus == 0 || orderStatus == 1 || orderStatus == 2) && this.handleAuth('fbb.logisticsHead.cancel'),
                    params: id,
                    operate: 'cancel'
                },
                {
                    label: this.$t('fbb.inbound.view_logistics', { defaultValue: '查看物流' }),
                    show: true,
                    params: id,
                    operate: 'seelogistics'
                },]
        },
        getOrderStatus(typeid) {
            let json = this.queryOrderStatusList.filter(item => {
                return item.value == typeid
            })
            return <span class={json[0].color}>{json[0].label}</span>
        },
        getLogisticsStatus(logid) {
            let logjson = this.logisticsStatusList.filter(item => {
                return item.value == logid
            })
            return <span class={logjson[0].color}>{logjson[0].label}</span>
        },
        getExceptionStatus(exceptid) {
            let excepjson = this.exceptionStatus.filter(item => {
                return item.value == exceptid
            })
            if (excepjson[0].label === this.$t('fbb.headlogistics.no_exceptioin', { defaultValue: '无异常' })) {
                return
            }
            return <span class={excepjson[0].color}>{excepjson[0].label}</span>
        },
        getTicketStatus (type) {
            let statusItem = this.ticketStatus.filter(item => {
                return item.value === type
            })[0]
            if (!statusItem) {
                return <span>--</span>
            }
            return <span class={statusItem.color}>{statusItem.label}</span>
        },
    },
    computed: {
        ...mapGetters('dictionary', ['getProductList', 'getSystemPortList', 'getCompanyList', 'getFilterDisabledWarehouse']),
        getCurrentTabNote() {
            let noteMap = {
                'quanbu':'',
                'daishenhe':'单据状态-待审核，物流状态-初始化',
                'daidingcang':'单据状态-已确认订舱，物流状态-待订舱',
                'daifachuan':'单据状态-已确认订舱，物流状态-已报关',
                'daiqingguan':'单据状态-发运中，物流状态-已发船',
                'daiyuyue':'单据状态-发运中，物流状态-已到港',
                'daituotou':'单据状态-发运中，物流状态-已预约',
                'daiscfp':'单据状态-已达到，物流状态-已妥投',
                'yifachuan':'单据状态-已确认订舱，物流状态-待订舱',
                'yichang':'',
                'yidaituotou':'',
                'jianyanzhong':'',
            }
            let noteStr = '';
            if (this.formData.search['daishenhe'] === 0) {
                noteStr = noteMap['daishenhe']
            }
            if (this.formData.search['daidingcang'] === 0) {
                noteStr = noteMap['daidingcang']
            }
            if (this.formData.search['daifachuan'] === 0) {
                noteStr = noteMap['daifachuan']
            }
            if (this.formData.search['daiqingguan'] === 0) {
                noteStr = noteMap['daiqingguan']
            }
            if (this.formData.search['daiyuyue'] === 0) {
                noteStr = noteMap['daiyuyue']
            }
            if (this.formData.search['daituotou'] === 0) {
                noteStr = noteMap['daituotou']
            }
            if (this.formData.search['daiscfp'] === 0) {
                noteStr = noteMap['daiscfp']
            }
            if (this.formData.search['yifachuan'] === 0) {
                noteStr = noteMap['yifachuan']
            }
            return noteStr
        },
        choseOrderStatusList() {
            return this.orderStatusList.filter(item => {
                return item.value != 10
            })
        },
        TabsData() {
            return [
                {
                    name: this.$t('global.common.all', { defaultValue: '全部' }),
                    key: 'quanbu',
                    val: 0
                },
                {
                    name: this.$t('fbb.headlogistics.daishenhe', { defaultValue: '待审核' }),
                    key: 'daishenhe',
                    val: 0,
                },
                {
                    name: this.$t('fbb.headlogistics.daidingcang', { defaultValue: '待订舱' }),
                    key: 'daidingcang',
                    val: 0,
                },
                {
                    name: this.$t('fbb.headlogistics.daifachuan', { defaultValue: "待发船" }),
                    key: 'daifachuan',
                    val: 0
                },
                {
                    name: this.$t('fbb.headlogistics.yifachuan', { defaultValue: "已发船" }),
                    key: 'yifachuan',
                    val: 0
                },
                {
                    name: this.$t('fbb.headlogistics.daiqingguan', { defaultValue: "待清关" }),
                    key: 'daiqingguan',
                    val: 0
                },
                {
                    name: this.$t('fbb.headlogistics.daiyuyue', { defaultValue: "待预约" }),
                    key: 'daiyuyue',
                    val: 0
                },
                {
                    name: this.$t('fbb.headlogistics.daituotou', { defaultValue: "待妥投" }),
                    key: 'daituotou',
                    val: 0
                },
                {
                    name: this.$t('fbb.headlogistics.yituotou', { defaultValue: "已妥投" }),
                    key: 'yidaituotou',
                    val: 0
                },
                // {
                //     name: "查验中",
                //     key: 'jianyanzhong',
                //     val: 0
                // },
                {
                    name: this.$t('fbb.headlogistics.daishangchuanfapiao', { defaultValue: "待上传发票" }),
                    key: 'daiscfp',
                    val: 0
                },
                {
                    name: this.$t('fbb.headlogistics.yichang', { defaultValue: "异常" }),
                    key: 'yichang',
                    val: 0,
                },
            ]
        },
        ToolsData() {
            return [
                {
                    name: this.$t('global.common.add', { defaultValue: "添加" }),
                    operate: "add",
                    theme: "primary",
                    show: this.handleAuth('fbb.logisticsHead.create')
                },
                {
                    name: this.$t('global.common.export', { defaultValue: '导出' }),
                    operate: 'export',
                    theme: 'primary'
                },
                {
                    name: this.$t('fbb.headlogistics.set_incharge', { defaultValue: '指定负责人' }),
                    operate: 'inCharge',
                    batch: true
                }
            ]
        },
        SearchsData() {
            let widthStyle = 'width: 220px;'
            return [
                {
                    label: this.$t('fbb.headlogistics.prelogistics_number', { defaultValue: "头程单号" }),
                    tag: 'vInput',
                    key: 'EQ_preLogisticsNo',
                    show: true,
                    style: 'width: 130px;'
                },
                {
                    label: this.$t('fbb.headlogistics.logistics_type', { defaultValue: "发运类型" }),
                    tag: 'Select',
                    key: 'EQ_logisticsType',
                    options: [
                        { value: 'transfer', label: this.$t('fbb.headlogistics.logistics_type_transfer', { defaultValue: '中转' }) },
                        { value: 'through', label: this.$t('fbb.headlogistics.logistics_type_through', { defaultValue: '直达' }) }
                    ],
                    props: {
                        filterable: true,
                    },
                    show: true,
                    style: 'width: 130px;'
                },
                {
                    label: this.$t('fbb.headlogistics.sublogistics_number', { defaultValue: "关联计划单号" }),
                    tag: 'vInput',
                    key: 'CN_subLogisticsNos',
                    show: true,
                    style: 'width: 130px;'
                },
                {
                    label: this.$t('fbb.headlogistics.associated_number', { defaultValue: "来源单号" }),
                    tag: 'vInput',
                    key: 'EQ_associatedNo',
                    style: widthStyle
                },
                {
                    label: this.$t('fbb.headlogistics.order_status', { defaultValue: "单据状态" }),
                    tag: 'Select',
                    key: 'IN_orderStatus',
                    options: this.queryOrderStatusList,
                    props: {
                        filterable: true,
                        multiple: true
                    },
                    style: widthStyle
                },
                {
                    label: this.$t('fbb.headlogistics.carrier_type', { defaultValue: "货代类型" }),
                    tag: 'Select',
                    key: 'EQ_carrierType',
                    options: [
                        { value: 0, label: this.$t('fbb.headlogistics.carrier_type_standard', {  defaultValue: '标准' }) },
                        { value: 1, label: this.$t('fbb.headlogistics.carrier_type_other', {  defaultValue: '其他' }) },
                    ],
                    props: {
                        filterable: true,
                    },
                    style: widthStyle
                },
                {
                    label: this.$t('global.common.line', { defaultValue: '项目' }),
                    key: 'IN_lineId',
                    tag: 'Select',
                    options: this.getProductList,
                    props: {
                        filterable: true,
                        multiple: true
                    },
                    style: widthStyle
                },

                // {
                //     label: "物流状态",
                //     tag: 'Select',
                //     key: 'IN_logisticsStatus',
                //     options: this.logisticsStatusList,
                //     props: {
                //         filterable: true,
                //     },
                //     style: widthStyle
                // },
                {
                    label: this.$t('fbb.headlogistics.transport_type', { defaultValue: "发运方式" }),
                    tag: 'Select',
                    key: 'IN_transportType',
                    options: this.transportList,
                    props: {
                        filterable: true,
                    },
                    style: widthStyle
                },
                {
                    label: this.$t('fbb.headlogistics.estimate_sail_at', { defaultValue: "预计开船日期" }),
                    tag: 'vDatepicker',
                    key: 'BT_estimateSailAt',
                    // default:this.initData,
                    props:{
                        options:this.options,
                        format:'yyyy-mm-dd ~ yyyy-mm-dd',
                        confirm:false,
                    },
                    style: widthStyle
                },
                {
                    label: this.$t('fbb.headlogistics.forwarder', { defaultValue: "货代公司" }),
                    tag: 'Select',
                    key: 'EQ_forwarderId',
                    options: this.getCompanyList,
                    props: {
                        filterable: true,
                    },
                    style: widthStyle
                },
                {
                    label: this.$t('fbb.headlogistics.customer_depot', { defaultValue: "目的仓" }),
                    tag: 'Select',
                    key: 'EQ_subLogisticsHeadList.customerDepotId',
                    options: this.getFilterDisabledWarehouse,
                    props: {
                        filterable: true,
                    },
                    style: widthStyle
                },
                {
                    label: this.$t('fbb.headlogistics.expect_port_arrival_date', { defaultValue: "预计到港日期" }),
                    tag: 'vDatepicker',
                    key: 'BT_expectPortArrivalDate',
                    // default:this.initData,
                    props:{
                        options:this.options,
                        format:'yyyy-mm-dd ~ yyyy-mm-dd',
                        confirm:false,
                    },
                    style: widthStyle
                },
                {
                    label: this.$t('fbb.headlogistics.ship_port', { defaultValue: "发运港" }),
                    tag: 'Select',
                    key: 'EQ_shipPortId',
                    options: this.getSystemPortList,
                    props: {
                        filterable: true,
                    },
                    style: widthStyle
                },
                {
                    label: this.$t('fbb.headlogistics.purpose_port', { defaultValue: "目的港" }),
                    tag: 'Select',
                    key: 'EQ_purposePortId',
                    options: this.getSystemPortList,
                    props: {
                        filterable: true,
                    },
                    style: widthStyle
                },
                {
                    label: this.$t('fbb.headlogistics.actual_sail_at', { defaultValue: "开船日期" }),
                    tag: 'vDatepicker',
                    key: 'BT_actualSailAt',
                    // default:this.initData,
                    props:{
                        options:this.options,
                        format:'yyyy-mm-dd ~ yyyy-mm-dd',
                        confirm:false,
                    },
                    style: widthStyle
                },
                {
                    label: this.$t('fbb.headlogistics.invoice_status', { defaultValue: "发票状态" }),
                    tag: 'Select',
                    key: 'EQ_invoiceStatus',
                    options: [
                        { value: 10, label: this.$t('fbb.headlogistics.invoice_10', { defaultValue: '发票未上传' }) },
                        { value: 20, label: this.$t('fbb.headlogistics.invoice_20', { defaultValue: '发票已上传' }) },
                        { value: 30, label: this.$t('fbb.headlogistics.invoice_30', { defaultValue: '发票已确认' }) }
                    ],
                    props: {
                        filterable: true,
                    },
                    style: widthStyle
                },
                {
                    label: this.$t('fbb.headlogistics.exception_status', { defaultValue: "异常状态" }),
                    tag: 'Select',
                    key: 'EQ_exceptionStatus',
                    options: this.exceptionStatus,
                    props: {
                        filterable: true,
                    },
                    style: widthStyle
                },
                {
                    // label: this.$t('fbb.headlogistics.logistics_number', { defaultValue: "物流单号/提单号" }),
                    label: `${this.$t('fbb.headlogistics.logistics_number_logistics', { defaultValue: '物流单号' })}/${this.$t('fbb.headlogistics.logistics_number', { defaultValue: '提单号' })}`,
                    tag: 'vInput',
                    key: 'EQ_logisticsNo',
                    style: widthStyle
                },
                {
                    label: this.$t('fbb.headlogistics.designated_person', { defaultValue: "负责人" }),
                    tag: 'vInput',
                    key: 'EQ_designatedPerson',
                    style: widthStyle
                },
                {
                    label: this.$t('fbb.headlogistics.forwarder_warehouse', { defaultValue: "中转仓" }),
                    tag: 'Select',
                    key: 'EQ_forwarderWarehouseId',
                    options: this.getFilterDisabledWarehouse,
                    props: {
                        filterable: true,
                    },
                    style: widthStyle
                },
                {
                    label: this.$t('fbb.headlogistics.arrival_at', { defaultValue: "到港日期" }),
                    tag: 'vDatepicker',
                    key: 'BT_arriveAt',
                    // default:this.initData,
                    props:{
                        options:this.options,
                        format:'yyyy-mm-dd ~ yyyy-mm-dd',
                        confirm:false,
                    },
                    style: widthStyle
                },
                {
                    label: this.$t('fbb.headlogistics.factory_batch_number', { defaultValue: "工厂批次号" }),
                    tag: 'vInput',
                    key: 'CN_factoryBatchNo',
                    style: widthStyle
                },
                {
                    label: this.$t('fbb.headlogistics.container_number', { defaultValue: "集装箱号" }),
                    tag: 'vInput',
                    key: 'CN_containerNo',
                    style: widthStyle
                },
                {
                    label: this.$t('fbb.headlogistics.expect_warehouse_arrval_date', { defaultValue: "预计到仓日期" }),
                    tag: 'vDatepicker',
                    key: 'BT_expectWarehouseArrivalDate',
                    // default:this.initData,
                    props:{
                        options:this.options,
                        format:'yyyy-mm-dd ~ yyyy-mm-dd',
                        confirm:false,
                    },
                    style: widthStyle
                },
                {
                    label: this.$t('fbb.headlogistics.voyage_name', { defaultValue: "船名航次" }),
                    tag: 'vInput',
                    key: 'EQ_voyageName',
                    style: widthStyle
                },
                {
                    label: this.$t('fbb.headlogistics.address_code', { defaultValue: "FBA门店" }),
                    tag: 'Select',
                    key: 'CN_subLogisticsHeadList.addressCode',
                    options: this.addressCodeList,
                    props: {
                        filterable: true,
                    },
                    style: widthStyle
                },
                {
                    label: this.$t('fbb.headlogistics.stock_in', { defaultValue: "妥投日期" }),
                    tag: 'vDatepicker',
                    key: 'BT_stockinAt',
                    // default:this.initData,
                    props:{
                        options:this.options,
                        format:'yyyy-mm-dd ~ yyyy-mm-dd',
                        confirm:false,
                    },
                    style: widthStyle
                },
                {
                    label: "Shipment id",
                    tag: 'vInput',
                    key: 'EQ_subLogisticsHeadList.shipmentId',
                    // default:this.initData,
                    style: widthStyle
                },
                {
                    label: this.$t('fbb.headlogistics.expect_stuffing_date', { defaultValue: '预计交货日期' }),
                    tag: 'vDatepicker',
                    key: 'BT_expectStuffingDate',
                    props:{
                        options:this.options,
                        format:'yyyy-mm-dd ~ yyyy-mm-dd',
                        confirm:false,
                    },
                    style: widthStyle
                },
                {
                    label: this.$t('fbb.headlogistics.customer_tax_no', { defaultValue: '税号' }),
                    tag: 'vInput',
                    key: 'EQ_taxNumber',
                    // default:this.initData,
                    style: widthStyle
                },
            ]
        },
        columns() {
            return [
                {
                    show: false,
                    type: 'selection',
                    width: 40,
                    align: 'center',
                    formName: 'id',
                    // fixed: 'left'
                }, {
                    title: this.$t('global.common.operation', { defaultValue: '操作' }),
                    width: 70,
                    render: this.getOperateNodes,
                    // fixed: 'left'
                }, {
                    // title: this.$t('fbb.headlogistics.id_source_id', { defaultValue: '头程单号/来源单号/关联计划单号/提单号/异常' }),
                    title: `${this.$t('fbb.headlogistics.prelogistics_number', { defaultValue: '头程单号' })}/${this.$t('fbb.headlogistics.associated_number', { defaultValue: '来源单号' })}/${this.$t('fbb.headlogistics.sublogistics_number', { defaultValue: '关联计划单号' })}/${this.$t('fbb.headlogistics.logistics_number', { defaultValue: '提单号' })}/${this.$t('fbb.headlogistics.exception', { defaultValue: '异常' })}`,
                    sortable: true,
                    // fixed: 'left',
                    render: (h, { row }) => {
                        // let row = {
                        //     exceptionStatus: 4,
                        //     subLogisticsHeadList: [{
                        //         exceptionStatus: 6
                        //     }, {
                        //         exceptionStatus: 5
                        //     }]
                        // }
                        let mainException = row.exceptionStatus
                        let exceptionList = []
                        row.subLogisticsHeadList.map(item => {
                            if (item.exceptionStatus !== mainException && item.exceptionStatus !== 0) {
                                exceptionList.push(this.getExceptionStatus(item.exceptionStatus))
                                exceptionList.push(',')
                            }
                        })
                        if (exceptionList.length > 0) {
                            console.log(exceptionList)
                        }
                        if (exceptionList[exceptionList.length - 1] === ',') {
                            exceptionList.splice(exceptionList.length - 1)
                        }
                        let exceptionDiv = (
                            <span>
                                {this.getExceptionStatus(mainException)}{mainException && exceptionList.length > 0 ? ',' : ''}{exceptionList}
                            </span>
                        )
                        let result = row.subLogisticsNos.split(',').map((item, index) => {
                            let split = ','
                            if (index === row.subLogisticsNos.split(',').length - 1) {
                                split = ''
                            }
                            return (
                                <span>
                                    <a onClick={this.handleOperates.bind(this, item, 'queryPlanBlank')}>{item}</a>{split}
                                </span>
                            )
                        })
                        return <div>
                            <div>
                                <a onClick={this.handleOperates.bind(this, row.id, 'query')}>{row.preLogisticsNo || '--'}</a>
                                <a onClick={this.handleOperates.bind(this, row.id, 'queryBlank')}><vIcon class="margin-left-10 font-14" type="ios-browsers-outline" /></a>
                            </div>
                            <div>{row.associatedNo || '--'}</div>
                            <div>
                                {result}
                            </div>
                            <div>{row.logisticsNo || '--'}</div>
                            <div>{exceptionDiv}</div>
                        </div>
                    }
                },
                {
                    // title: this.$t('fbb.headlogistics.logistics_type_project', { defaultValue: '发运类型/项目' }),
                    title: `${this.$t('fbb.headlogistics.logistics_type', { defaultValue: '发运类型' })}/${this.$t('global.common.line', { defaultValue: '项目' })}`,
                    // key: 'sourceChannel',
                    // width: (this.formData.search['quanbu'] === 0) ? 100 : 'auto',
                    render: (h, { row }) => {
                        let logistics;
                        switch (row.logisticsType) {
                            case 'transfer': logistics = this.$t('fbb.headlogistics.logistics_type_transfer', { defaultValue: '中转' }); break;
                            case 'through': logistics = this.$t('fbb.headlogistics.logistics_type_through', { defaultValue: '直发' }); break;
                        }
                        let product = this.getProductList.filter(item => {
                            return item.value == row.lineId
                        })[0] || {}
                        return <div>
                            <div>{logistics || '--'}</div>
                            <div>{product.label || '--'}</div>
                        </div>
                    }
                },
                {
                    title: this.$t('fbb.headlogistics.customer_depot', { defaultValue: '目的仓' }),
                    render: (h, { row }) => {
                        let orgWarehouseCodesEle = row.orgWarehouseCodes ? row.orgWarehouseCodes.split(',').map(item => {
                            return <div>{item}</div>
                        }) : "--";
                        return <div>
                            <div>{orgWarehouseCodesEle || '--'}</div>
                        </div>
                    }
                },
                {
                    // title: '单据状态/发票状态',
                    title: `${this.$t('fbb.headlogistics.order_status', { defaultValue: '单据状态' })}/${this.$t('fbb.headlogistics.invoice_status', { defaultValue: '发票状态' })}`,
                    // width: 60,
                    width: (this.formData.search['quanbu'] === 0) ? 80 : 'auto',
                    render: (h, { row }) => {
                        return <div>
                            <div>{this.getOrderStatus(row.orderStatus)}</div>
                            <div>{this.getTicketStatus(row.invoiceStatus)}</div>
                        </div>
                    }
                },
                {
                    // title: '货代类型/货代公司',
                    title: `${this.$t('fbb.headlogistics.carrier_type', { defaultValue: '货代类型' })}/${this.$t('fbb.headlogistics.forwarder', { defaultValue: '货代公司' })}`,
                    width: 100,
                    render: (h, { row }) => {
                        let carrierTypeMap = {
                            0: this.$t('fbb.headlogistics.carrier_type_standard', { defaultValue: "标准" }),
                            1: this.$t('fbb.headlogistics.carrier_type_other', { defaultValue: "其他" }),
                        }
                        return <div>
                            <div>{carrierTypeMap[row.carrierType] || '--'}</div>
                            <div>{row.forwarderName || '--'}</div>
                        </div>
                    }
                },
                {
                    // title: '发运方式/发运港/目的港',
                    title: `${this.$t('fbb.headlogistics.transport_type', { defaultValue: '发运方式' })}/${this.$t('fbb.headlogistics.ship_port', { defaultValue: '发运港' })}/${this.$t('fbb.headlogistics.purpose_port', { defaultValue: '目的港' })}`,
                    // width: 100,
                    render: (h, { row }) => {
                        let shipname;
                        switch (row.transportType) {
                            case 0: shipname = this.$t('fbb.headlogistics.fcl_by_sea', { defaultValue: '海运整柜FCL' }); break;
                            case 1: shipname = this.$t('fbb.headlogistics.air_transport', { defaultValue: '空运' }); break;
                            case 6: shipname = this.$t('fbb.headlogistics.ltl_by_sea', { defaultValue: 'LTL海运拼箱' }); break;
                            case 7: shipname = this.$t('fbb.headlogistics.lcl_by_sea', { defaultValue: '自拼箱' }); break;
                            case 8: shipname = this.$t('fbb.headlogistics.express', { defaultValue: '快递' }); break;
                            case 9: shipname = this.$t('fbb.headlogistics.sea_transport', { defaultValue: '海运' }); break;
                            case 99: shipname = '--'; break;
                        }
                        return <div>
                            <div>{shipname || '--'}</div>
                            <div>{row.shipPort || '--'}</div>
                            <div>{row.purposePort || '--'}</div>
                        </div>
                    }
                },
                {
                    title: this.$t('fbb.headlogistics.expect_stuffing_date', { defaultValue: '预计交货日期' }),
                    width:(this.formData.search['daishenhe']===0||this.formData.search['daidingcang']===0) ? 110 : 0,
                    sortable: true,
                    key:'expectStuffingDate',
                    render: (h, { row }) => {
                        let val = ""
                        if (row.expectStuffingDate) {
                            val = row.expectStuffingDate.split(" ")[0]
                        }
                        return <div>
                            <div>{val || '--'}</div>
                        </div>
                    }
                },
                {
                    title: this.$t('fbb.headlogistics.actual_loading_date', { defaultValue: '实际装柜日期' }),
                    sortable:true,
                    width:(this.formData.search['yifachuan']===0) ? 110 : 0,
                    key:'actualLoadingDate ',
                    render: (h, { row }) => {
                        let val = ""
                        if (row.actualLoadingDate) {
                            val = row.actualLoadingDate.split(" ")[0]
                        }
                        return <div>
                            <div>{val  || '--'}</div>
                        </div>
                    }
                },
                {
                    title: this.$t('fbb.headlogistics.estimate_sail_at', { defaultValue: '预计开船日期' }),
                    sortable:true,
                    width:(this.formData.search['daifachuan']===0) ? 110 : 0,
                    key:"estimateSailAt",
                    render: (h, { row }) => {
                        let val = ""
                        if (row.estimateSailAt) {
                            val = row.estimateSailAt.split(" ")[0]
                        }
                        return <div>
                            <div>{val || '--'}</div>
                        </div>
                    }
                },
                {
                    title: this.$t('fbb.headlogistics.actual_sail_at', { defaultValue: '实际开船日期' }),
                    sortable:true,
                    width:(this.formData.search['yifachuan']===0||this.formData.search['daiqingguan']===0) ? 110 : 0,
                    key:'actualSailAt',
                    render: (h, { row }) => {
                        let val = ""
                        if (row.actualSailAt) {
                            val = row.actualSailAt.split(" ")[0]
                        }
                        return <div>
                            <div>{val  || '--'}</div>
                        </div>
                    }
                },
                {
                    title: this.$t('fbb.headlogistics.expect_port_arrival_date', { defaultValue: '预计到港日期' }),
                    width:(this.formData.search['yifachuan']===0||this.formData.search['daiqingguan']===0) ? 110 : 0,
                    sortable: true,
                    key:'expectPortArrivalDate',
                    render: (h, { row }) => {
                        let val = ""
                        if (row.expectPortArrivalDate) {
                            val = row.expectPortArrivalDate.split(" ")[0]
                        }
                        return <div>
                            <div>{val || '--'}</div>
                        </div>
                    }
                },
                {
                    title: this.$t('fbb.headlogistics.customer_clearance_date', { defaultValue: '清关日期' }),
                    width:(this.formData.search['daiyuyue']===0) ? 110 : 0,
                    sortable: true,
                    key:'customerClearanceDate',
                    render: (h, { row }) => {
                        let val = ""
                        if (row.customerClearanceDate) {
                            val = row.customerClearanceDate.split(" ")[0]
                        }
                        return <div>
                            <div>{val || '--'}</div>
                        </div>
                    }
                },
                {
                    title: this.$t('fbb.headlogistics.arrive_at', { defaultValue: '实际到港日期' }),
                    width:(this.formData.search['daiyuyue']===0||this.formData.search['jianyanzhong']===0) ? 110 : 0,
                    sortable: true,
                    key:'arriveAt',
                    render: (h, { row }) => {
                        let val = ""
                        if (row.arriveAt) {
                            val = row.arriveAt.split(" ")[0]
                        }
                        return <div>
                            <div>{val || '--'}</div>
                        </div>
                    }
                },
                {
                    title: this.$t('fbb.headlogistics.appointment_at', { defaultValue: '预约送仓时间' }),
                    sortable: true,
                    key:'appointmentAt',
                    width:(this.formData.search['daituotou']===0||this.formData.search['daituotou']===0) ? 120 : 0,
                    render: (h, { row }) => {
                        return <div>
                            <div>{row.appointmentAt || '--'}</div>
                        </div>
                    }
                },
                {
                    title: this.$t('fbb.headlogistics.expect_warehouse_arrval_date', { defaultValue: '预计到仓日期' }),
                    sortable: true,
                    key:'expectWarehouseArrivalDate',
                    width:(this.formData.search['daituotou']===0) ? 110 : 0,
                    render: (h, { row }) => {
                        let val = ""
                        if (row.expectWarehouseArrivalDate) {
                            val = row.expectWarehouseArrivalDate.split(" ")[0]
                        }
                        return <div>
                            <div>{val || '--'}</div>
                        </div>
                    }
                },
                {
                    title: this.$t('fbb.headlogistics.stock_in', { defaultValue: '妥投日期' }),
                    sortable:true,
                    width:(this.formData.search['yidaituotou']===0 || this.formData.search['daiscfp']===0) ? 110 : 0,
                    key:'stockinAt',
                    render: (h, { row }) => {
                        let val = ""
                        if (row.stockinAt) {
                            val = row.stockinAt.split(" ")[0]
                        }
                        return <div>
                            <div>{val || '--'}</div>
                        </div>
                    },
                },
                {
                    title: this.$t('fbb.fedex.estimatedCost', { defaultValue: '预估费用' }),
                    render: (h, { row }) => {
                        return (
                            <div>
                                <div>{this.$t('fbb.billmanage.total_cost', { defaultValue: '总费用' })}:{row.price}</div>
                                <div>{this.$t('fbb.headlogistics.expect_china_cost', { defaultValue: `中国段预估费用` })}:{row.chinaEstimateCost}</div>
                                <div>{this.$t('fbb.headlogistics.expect_sea_delivery_cost', { defaultValue: `预估海运费` })}:{row.oceanFreightEstimate}</div>
                                <div>{this.$t('fbb.headlogistics.destination_cost', { defaultValue: `目的国费用` })}:{row.destinationEstimateCost}</div>
                                <div>{this.$t('fbb.headlogistics.tariff', { defaultValue: `关税` })}:{row.tariffEstimate}</div>
                            </div>
                        )
                    }
                },
                {
                    title: "实际费用",
                    render: (h, { row }) => {
                        return (
                            <div>
                                <div>{this.$t('fbb.headlogistics.deliver_total_cost', { defaultValue: '运费总计' })}:{row.totalCost}</div>
                                <div>{this.$t('fbb.headlogistics.cost_china', { defaultValue: '中国段费用' })}:{row.chinaCost}</div>
                                <div>{this.$t('fbb.headlogistics.cost_sea', { defaultValue: '海运费' })}:{row.oceanFreight}</div>
                                <div>{this.$t('fbb.headlogistics.destination_cost', { defaultValue: "目的国费用" })}:{row.destinationCost}</div>
                                <div>{this.$t('fbb.headlogistics.tariff', { defaultValue: `关税` })}:{row.tariff}</div>
                                <div>{this.$t('erp.b2border.invoice', { defaultValue: '发票号' })}:{row.invoiceNo || "--"}</div>
                            </div>
                        )
                    }
                },
                {
                    // title: '负责人/更新时间',
                    title: `${this.$t('fbb.headlogistics.designated_person', { defaultValue: '负责人' })}/${this.$t('global.common.update_time', { defaultValue: '更新时间' })}`,
                    key: 'updatedAt',
                    width: 180,
                    render: (h, { row }) => {
                    return <div>
                        <div>{row.designatedPerson || '--'}</div>
                        <div>{row.updatedAt}</div>
                    </div>
                    }
                },
            ];
        },

    },

};
